import { Stack, Typography } from '@mui/material';
import {
  AfterSubmitProps,
  DateInput,
  FormFieldsData,
  FormShowTemplate,
  InputList,
  TextInput,
  useFormContext,
} from 'framework/form';
import { Button } from 'framework/ui/mui-builder';

import { inviteClientUsersValidation } from './inviteClientUserValidation';

type InviteClientUsersDrawerContentProps = {
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
  afterSubmit?: AfterSubmitProps<(response: Response) => void, string | ((response: Response) => string)>;
  budgetEndDate?: string;
};

const SubmitRequestButton = () => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact } = useFormContext();

  return (
    <Button
      fullWidth
      disabled={!isSubmitEnabled || isLoadingArtifact}
      loading={isLoadingArtifact}
      onClick={() => submitForm?.()}
    >
      Submit request
    </Button>
  );
};

const InviteClientUsersDrawerContent = ({
  submitFormFunc,
  afterSubmit,
  budgetEndDate,
}: InviteClientUsersDrawerContentProps) => {
  const defaultClientRow = {
    firstName: '',
    lastName: '',
    email: '',
    accessUntil: budgetEndDate ?? '',
  };

  return (
    <FormShowTemplate
      initEditMode
      initialData={{ clients: [defaultClientRow] }}
      submitFormFunc={submitFormFunc}
      afterSubmit={afterSubmit}
      getValidationSchemaFunc={() => Promise.resolve(inviteClientUsersValidation)}
    >
      <Stack spacing={2} pb={4}>
        <Typography color="textSecondary">
          Provide the client details below. The request will be sent for approval, and once approved, the users will be
          automatically added to the Client Portal and invited to access it.
        </Typography>
        <InputList
          source="clients"
          addText="Add client"
          maxFields={30}
          minFields={1}
          defaultValue={defaultClientRow}
          rowSx={{ gap: 1, mb: 0, '.floating-label-input': { mb: 0 } }}
          inputTemplate={({ source }) => (
            <>
              <TextInput source={`${source}.firstName`} label="First name" />
              <TextInput source={`${source}.lastName`} label="Last name" />
              <TextInput source={`${source}.email`} label="Email" />
              <DateInput source={`${source}.accessUntil`} label="Access until" maxDate={budgetEndDate} />
            </>
          )}
        />
      </Stack>
      <SubmitRequestButton />
    </FormShowTemplate>
  );
};

export default InviteClientUsersDrawerContent;
